import { useState } from 'react';
import { getApiErrorMessage, postEmail } from '../services/emailApi';

const useSendClubeFeedback = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [response, setResponse] = useState(false);

  const sendFeedback = async (data) => {
    setLoading(true);
    setError(null);
    setResponse(null);

    try {
      const res = await postEmail('/feedback/club', data);
      setResponse(res.data.message);
    } catch (err) {
      setError(getApiErrorMessage(err, 'Erro ao enviar feedback'));
    } finally {
      setLoading(false);
    }
  };

  return { sendFeedback, response, loading, error };
};

export default useSendClubeFeedback;
